import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f90c600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "この商品について", -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "value line--only" }
const _hoisted_7 = {
  key: 1,
  class: "value line--only"
}

import { ref, onMounted, reactive } from 'vue'

interface keyVal {
  name: string;
  value: string;
}

export default /*#__PURE__*/_defineComponent({
  props: ['product'],
  setup(__props) {

const props = __props

const list = ref<keyVal[]>([])

onMounted(() => {
  const data = props.product.productPropsJa
  if (data) {
    list.value = JSON.parse(data)
  } else {
    list.value = []
  }
  console.log(list, 'list')
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.name
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
          (item.value && item.value.length > 14)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "light",
                class: "box-item",
                content: item.value,
                placement: "top"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    style: {"max-width":"200px"},
                    innerHTML: item.value
                  }, null, 8, _hoisted_5)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.value), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.value), 1))
        ]))
      }), 128))
    ])
  ]))
}
}

})